export default class {
    constructor() {
        this.loaded = false;
        this.googleClass = false;
        // Array of Promise resolves waiting for the map to load
        this.awaitingMap = [];

        //Prevent the race condition where the maps script loads before the mapLoaded callback is added
        //as this prevents the class from ever initialising any callbacks given
        if(window.google){
            this.mapLoaded()
        }
    }

    mapLoaded() {
        this.loaded = true;
        this.googleClass = google || false;
        if (this.googleClass === false) {
            console.error('GoogleMapsLoaderwas loaded but global google object was not set');
            return;
        }
        this.awaitingMap.forEach(awaitingMap => {
            awaitingMap(this.googleClass);
        });
    }

    /**
     * Get the global Google instance
     */
    getMap() {
        return new Promise((resolve, reject) => {
            if (this.loaded == true) {
                if (this.googleClass === false) {
                    console.error('GoogleMapsLoader is loaded but googleClass was not set');
                    reject();
                    return;
                }
                resolve(this.googleClass);
                return;
            }

            this.awaitingMap.push(googleClass => {
                if (!this.googleClass) {
                    this.googleClass = googleClass;
                }
                resolve(googleClass)
            });
        });
    }
}